<template>
    <div class="register">
        <div class="partner-form">
            <div>
                <div class="partner-formTitle">企业伙伴注册</div>
                <div class="partner-formCon">

                    <div class="partner-formInput">
                        <span>工作邮箱</span>

                        <input type="text" class="partner-check" v-model="email" placeholder="必填" name="email" @change="checkIsPartner">
                    </div>

                    <div class="partner-formInput">
                        <span>手机号</span>

                        <input type="text" class="partner-check" v-model="mobile" placeholder="必填" maxlength="11" name="telephone" @change="checkIsPartner">
                    </div>

                    <div class="partner-formInput">
                        <span>图形验证码</span>

                        <input type="text" v-model="picCode" placeholder="必填" class="input_code" id="input_code">
                        <div class="picCode-content">
                            <img :src="picCodeImage" alt="" title="图形验证码" id="picCode">
                            <a @click="getPicCode" class="changeCode">看不清，换一换</a>
                        </div>
                    </div>

                    <div class="partner-formInput">
                        <span>短信验证码</span>

                        <input type="text" v-model="smsCode" placeholder="必填" name="verifyCode">
                        <a @click="sendSmsCode" class="getSms" :class="{ active: smsCodeCountDown <= 0}">{{getSendSmsCodeText()}}</a>
                    </div>

                    <div class="resend">
                        <span style="font-weight:500;">没收到验证邮件？</span>
                        <a class="button-resend" id="resendEmail" @click="sendEmail">点此重发</a>
                    </div>

                </div>

                <div class="sin_container agreeDiv">
                    <div class="input__top">
                      <RcclCheckBox class="partner-check-box"
                                    :customItem="'checkAll'"
                                    :defaultChecked="isCheckAll"
                                    v-on:onChanged="handleCheckAll"/>
                      <div class="agree_content">
                        同意以下所有政策
                      </div>
                    </div>
                    <div class="input__top">
                        <RcclCheckBox class="partner-check-box"
                        :customItem="'agreeEmail'"
                        :defaultChecked="wantToAgreeEmail"
                        v-on:onChanged="checkBoxChanged"/>
                        <div class="agree_content">
                            我同意接收皇家加勒比游轮船务（中国）有限公司及其关联公司的优惠资讯及推送信息。
                        </div>
                    </div>
                    <div class="input__top">
                        <RcclCheckBox class="partner-check-box"
                        :customItem="'allowTui'"
                        :defaultChecked="wantToAllowTui"
                        v-on:onChanged="checkBoxChanged"/>
                        <div class="agree_content">
                            我同意将注册信息（即邮箱及手机号）分享给皇家加勒比游轮海外航线销售合作伙伴（即中旅途易旅游有限公司北京绿洲旅游分公司），以自动登录至其网站搜索和获取海外航线的优先合作伙伴折扣信息。
                        </div>
                    </div>
                    <div class="input__top agreeCheckBoxForm">
                        <RcclCheckBox 
                        :customItem="'privacy'"
                        :defaultChecked="wantToAgreePrivacy"
                        v-on:onChanged="checkBoxChanged"/>
                        <div class="agree_content agree_privacy_content">
                            我已阅读并同意<a href="/Rccl.UserCenter/Privacy" target="_blank"
                                class="privacyLink external">*《隐私政策》*</a>。
                        </div>
                    </div>
                </div>

                <div class="partner-formLogin js-loginBtn registerButton"><button @click="onRegisterConfirm">提交资料</button></div>
                <p class="partner-registerLink"><router-link to="/Rccl.Partner/Partner/Login">已有账号登录&nbsp;&gt;</router-link></p>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
const RcclCheckBox = () => import('@/components/Common/RcclCheckBox')
export default {
    name: "PartnerRegister",
    components: {
        RcclCheckBox
    },
    data () {
        return {
            picCodeImage: "",
            mobile: "",
            email: "",
            picCode: "",
            smsCode: "",
            smsCodeCountDown: 0,
            wantToAllowTui: false,
            wantToAgreeEmail: false,
            wantToAgreePrivacy: false,
            isCheckAll: false
        }
    },
    beforeMount() {
        this.getPicCode()
    },
    methods: {
        handleCheckAll() {
          this.wantToAgreePrivacy = this.wantToAllowTui = this.wantToAgreeEmail = this.isCheckAll =! this.isCheckAll;
        },
        async checkIsPartner () {
            const { success, data } = await api.partner.checkIsPartner({
                telephone: this.mobile,
                email: this.email
            })
            if (success) {
                if (data) {
                    const self = this
                    this.$alert.show("您已经注册过了，请直接登录", {
                        confirmCallBack () {
                            self.$router.push({
                                name: "PartnerLogin"
                            })
                        }
                    })
                }
            }
        },
        async onRegisterConfirm () {
            if (!this.checkRequestData()) {
                return
            }
            const requestData = {
                email: this.email,
                telephone: this.mobile,
                verifyCode: this.smsCode,
                isAllowTui: this.wantToAllowTui,
                isAgreeEmail: this.wantToAgreeEmail,
                sessionKey: this.sessionKey
            }
            this.$loading.show()
            const { success, errMsg } = await api.partner.register(requestData)
            this.$loading.hide()
            if (!success) {
                this.$alert.show(errMsg)
            } else {
              this.$alert.show("注册成功！请激活您的账户，我们已向您的邮箱发送了一封激活邮件。", {
                confirmCallBack: ()=> {
                  const returnUrl = this.$router.currentRoute.query.returnUrl
                  if (returnUrl && returnUrl.length > 0) {
                    location.href = returnUrl
                  } else {
                    this.$router.push({
                      name: "PartnerIndex"
                    })
                  }
                }
              });
            }
        },
        async sendEmail () {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
                return this.onRegisterConfirm()
            } else {
                const { success } = await api.partner.sendEmail({})
                if (success) {
                    this.$alert.show("发送成功")
                } else {
                    return this.onRegisterConfirm()
                }
            }
        },
        async getPicCode () {
            const { success, data, errMsg } = await api.user.picCode(this.sessionKey)
            if (!success) console.error(errMsg)
            if (data) {
                this.picCodeImage = "data:image/png;base64," + data.imageBase64
                this.$store.dispatch('SET_SESSION_KEY', data.sessionKey)
            }
        },
        async sendSmsCode (){
            if (this.smsCodeCountDown > 0) {
                return
            }
            if (this.picCode == '') {
                this.$alert.show("请输入图形验证码")
                return
            }
            this.$loading.show()
            const { success, errMsg } = await api.user.smsCode({
                phone: this.mobile,
                picCode: this.picCode,
                callingCode: '86',
                sessionKey: this.sessionKey
            })
            this.$loading.hide()
            if (!success) {
                console.error(errMsg)
                this.$alert.show(errMsg)
                return
            } else {
                this.$alert.show("短信发送成功！若您没有收到短信验证，请一分钟后重新发送。")
            }
            
            this.getPicCode()
            this.smsCodeCountDown = 60
            const self = this
            let countDown = setInterval(()=> {
                if (self.smsCodeCountDown == 0) {
                    clearInterval(countDown)
                } else {
                    self.smsCodeCountDown--
                }
                
            }, 1000)

        },
        getSendSmsCodeText () {
            if (this.smsCodeCountDown <= 0) {
                return "发送验证码"
            } else {
                return `验证码(${this.smsCodeCountDown}s)`
            }
        },
        checkBoxChanged (isChecked, item) {
            if (item == 'privacy') {
                this.wantToAgreePrivacy = isChecked
            } else if (item == 'allowTui') {
                this.wantToAllowTui = isChecked
            } else if (item == 'agreeEmail') {
                this.wantToAgreeEmail = isChecked
            }

            this.isCheckAll = this.wantToAgreePrivacy && this.wantToAllowTui && this.wantToAgreeEmail;
        },
        checkRequestData () {
            if (!this.email || this.email == "") {
                this.$alert.show("请输入工作邮箱");
                return false;
            }
            if (!this.mobile || this.mobile == "") {
                this.$alert.show("请输入手机号");
                return false;
            }
            if (!this.smsCode || this.smsCode == "") {
                this.$alert.show("请输入短信验证码");
                return false;
            }

            if (!this.wantToAgreePrivacy) {
                this.$alert.show("请阅读并勾选隐私政策");
                return false;
            }

            return true
        }
    },
    computed: {
        sessionKey() {
            return this.$store.state.page.sessionKey
        }
    }
}
</script>

<style lang="less" scoped>
.register {
    background: url('https://resource.rcclchina.com.cn/partner/register-bg.jpg') no-repeat center;
    height: 800px;
    padding-top: 135px;
    position: relative;
    margin-top: -72px;
    z-index: 2;
    .partner-check-box {
        vertical-align: top;
    }
}

.partner-form > div {
    width: 530px;
    border-radius: 10px;
    background: white;
    margin: auto;
    padding: 30px 45px 20px 45px;
}

.partner-formTitle {
    color: #0059A5;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    letter-spacing: 2px;
}

.partner-formCon {
    margin-top: 20px;
}
.partner-formInput{
    position: relative;
    margin-bottom:16px;
}
.partner-formInput > span {
    display:block;
    text-align:left;
    font-size: 14px;
    font-weight: 400;
    color: #121920;
}

    .partner-formInput > input {
        background-color: #fff;
        width: 100%;
        height: 34px;
        line-height: 24px;
        color: #333;
        font-size: 18px;
        font-weight: bold;
        font-style: normal;
        border: none;
        -webkit-appearance: none;
        appearance: none;
        border-bottom: solid 1px #ccc;
    }

.partner-formInput > input::placeholder {
    font-size: 15px;
    font-weight: normal;
    color: #aaa;
}

    .partner-formInput .picCode-content {
        position: absolute;
        right: 0px;
        bottom: 7px;
    }

.partner-formInput > input[name='verifyCode'],
.partner-formInput > .input_code{
    /*width:174px;*/
}
    .partner-formInput .getSms, .partner-formInput .getSms:hover, .partner-formInput .getSms:active {
        color: #006699;
        font-size: 14px;
        font-weight: 400;
        position: absolute;
        right: 0px;
        display: block;
        bottom: 7px;
        text-decoration: none;
        color: #999999;
        cursor: pointer;
    }
        .partner-formInput .getSms.active, .partner-formInput .getSms.active:hover, .partner-formInput .getSms.active:active {
            color: #006699;
        }
.partner-formInput #picCode {
    width: 75px;
    display:inline-block;
    vertical-align: bottom;
}
    .partner-formInput .changeCode, .partner-formInput .changeCode:hover, .partner-formInput .changeCode:active {
        color: #006699;
        font-weight: 400;
        font-size: 14px;
        text-decoration: none;
        cursor: pointer;
    }

.partner-formCon .resend {
    font-size: 14px;
    font-weight: 400;
    color: #121920;
    text-align: right;
}

.partner-formLogin {
    margin-top: 20px;
}

    .partner-formLogin button {
        width: 100%;
        text-align: center;
        height: 55px;
        line-height: 55px;
        color: #000033;
        font-size: 19px;
        font-weight: 600;
        letter-spacing: 2px;
        background-color: #fcc400;
        border-radius: 6px;
    }
.partner-registerLink {
    margin-top: 20px;
    margin-bottom: 0px;
    text-align: right;
}
    .partner-registerLink > a, .partner-registerLink > a:hover, .partner-registerLink > a:active {
        color: #006699;
        text-decoration: none;
        font-weight: 400;
    }

.button-resend, .button-resend:hover, .button-resend:active {
    margin-left: 1px;
    display: inline-block;
    border-radius: 3px;
    color: #006699;
    font-weight: 400;
    font-size: 14px;
    text-decoration: none;
    cursor: pointer;
}

.agreeDiv {
    margin-top: 16px;
}

.agreeDiv .input__top {
    margin-bottom: 10px;
}

.checkBoxForm {
    display: inline-block;
    width: 18px;
    height: 18px;
}

.agree_content {
    display: inline-block;
    font-size: 12px;
    font-weight: 400;
    color: #121920;
    width: 410px;
    vertical-align: top;
    margin-left: 5px;
    letter-spacing: 1px;
}

.agree_privacy_content {
    vertical-align: middle;
}

.agreeBox {
    width: 18px;
    height: 18px;
    border: 1px solid #d3dadd;
    display: inline-block;
    vertical-align: middle;
    border-radius: 4px;
    position: relative;
    top: -4px;
}

    .agreeBox.active {
        background: url('/Modules/Rccl.UserCenter/image/PC/list/icon-checkBox-checked.png') no-repeat center;
        border-color: #006ab9;
    }

#termPolicy {
    opacity: 1;
    background: rgba(0, 0, 0, 0.2);
}

#rcclConfirmModal .modal-dialog {
    top: 100px;
}

.modal-title {
    margin-left: 22px !important;
}

.term p{
    font-size:14px;
    line-height:18px;
    font-weight:300;
}

.termTitle{
    margin-top: 23px;
    text-align: center;
    font-size: 20px;
    color: #006ab9;
    font-weight: bold;
    margin-bottom: 30px;
}


.termButton{
    text-align:center;
    margin-top:25px;
}
.termButton button,
.termButton button:hover,
.termButton button:focus,
.termButton button:active{
    color: #282b2c;
    background-color: #fcc301;
    border-color: #fcc301;
}

#termPolicy .modal-body{
    padding:40px;
}

#agreePolicy{
    margin-right:90px;
}

.button--orange{
    background:#fcc400;
}

.activeRule{
    text-align:center;
}
</style>